import Vue from 'vue';

import { globalMixin } from '@/mixins/global';

Vue.mixin(globalMixin);
